import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { Skeleton as ShadcnSkeleton } from '@/components/ui/skeleton';
import { AvatarWithName } from '../../../../../shared/components/Avatar';
import { DEFAULT_PER_PAGE as ROW_COUNT } from '../../../../shared/constants';

const ActionsCellSkeleton = () => <ShadcnSkeleton className="h-8 w-8 rounded-md" />;

const TextBlockSkeleton = ({ variant = 'light' }) => {
  const styles = cn('h-5 w-32', variant === 'dark' ? 'bg-gray-200/40' : '');

  return <ShadcnSkeleton className={styles} />;
};

TextBlockSkeleton.propTypes = {
  variant: PropTypes.oneOf(['light', 'dark']),
};

const HeaderSkeleton = () => (
  <div className="bg-muted grid grid-cols-4 px-2 py-2.5">
    {Array.from({ length: 4 }, (_, i) => (
      <TextBlockSkeleton key={i} variant="dark" />
    ))}
  </div>
);

const RowSkeleton = () => (
  <div className="border-t grid grid-cols-4 px-2 py-2.5 items-center">
    <AvatarWithName.Skeleton />
    <TextBlockSkeleton />
    <TextBlockSkeleton />

    <div className="flex items-center justify-between">
      <TextBlockSkeleton />
      <ActionsCellSkeleton />
    </div>
  </div>
);

const DataTableSkeleton = () => (
  <div className="border overflow-hidden rounded-md">
    <HeaderSkeleton />

    {Array.from({ length: ROW_COUNT }, (_, i) => (
      <RowSkeleton key={i} />
    ))}
  </div>
);

export default DataTableSkeleton;
